
import { defineComponent } from 'vue';
import commonApi from '@/api/common';
import { qrcanvas } from 'qrcanvas';

export default defineComponent({
  name: 'PayModal',
  data() {
    return {
      visible: false,
      checkedModal: 0,
      timer: 0,
      gradePayInfo: {
        codeUrl: '',
        payOrderNo: '',
        sn: '',
      },
      payStyle: {
        thirdPartyPayGroup: [
          {
            paymentId: '',
          },
        ],
      },
    };
  },
  props: ['payInfo'],
  components: {
  },
  mounted() {
    this.getPayFun();
  },
  methods: {
    checkPayMode(num: number) {
      console.log(num);
      this.checkedModal = num;
    },
    showModal() {
      this.visible = true;
    },
    getPayFun() {
      interface Data{
        data: any;
        success: boolean;
        message: string;
      }
      commonApi.getPayChannels({}).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.payStyle = data;
        } else {
          // this.error(message);
          console.log(message);
        }
      });
    },
    close() {
      this.gradePayInfo.codeUrl = '';
      clearInterval(this.timer);
    },
    goPay() {
      interface Data{
        data: {
          codeUrl: '';
          payOrderNo: '';
          sn: '';
        };
        success: boolean;
        message: string;
      }
      commonApi.upgradePay({
        versionType: this.payInfo.key ? this.payInfo.key : this.payInfo.versionType,
        paymentId: this.payStyle.thirdPartyPayGroup[this.checkedModal].paymentId,
        // amount: this.payInfo.value,
        amount: 0.01,
        rechargeNo: this.payInfo.rechargeNo ? this.payInfo.rechargeNo : '',
      }).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.gradePayInfo = data;
          const canvas = qrcanvas({
            data: this.gradePayInfo.codeUrl,
            size: 372,
          });
          const qrUrl: any|null = document.getElementById('qrcode');
          qrUrl.innerHTML = '';
          qrUrl.appendChild(canvas);
          this.timer = setInterval(() => {
            this.queryPayStatus();
          }, 1000);
        } else {
          // this.error(message);
          console.log(message);
        }
      });
    },
    queryPayStatus() {
    interface Data{
        data: number;
        success: boolean;
        message: string;
      }
    const params = {
      payOrderNo: this.gradePayInfo.payOrderNo,
      paymentId: this.payStyle.thirdPartyPayGroup[this.checkedModal].paymentId,
      type: 4,
    };
    commonApi.queryPayStatus(params).then(async ({ data, success, message }: Data) => {
      if (success) {
        console.log(data);
        if (data === 1) {
          // this.success('');
          this.close();
          this.$router.push('/payResult');
        }
      } else {
        console.log(message);
      }
    });
    },
  },
});
